// Angular
import { Injectable } from '@angular/core';

// Libraries
import _range from 'lodash-es/range';
import { wenji } from 'libraries/interfaces/IWenji';

@Injectable()
export class HelperService {
    public objectToArray (obj: any, limit?: any) {
        if (obj) {
            return Object.keys(obj).map((k) => obj[k]);
        } else {
            return [];
        }
    }

    public getDateFormat (): { momentShort: string } {
        return JSON.parse(wenji.ui.dateFormat);
    }

    public getRangeRating (rating: number): number[] {
        return _range(rating);
    }
}
